export var AXIOS_HTTP_ERROR = 'AXIOS_HTTP_ERROR';
export var TPLUS_HTTP_999 = 'TPLUS_HTTP_999';
export var TPLUS_LOGIN_ERROR = 'TPLUS_LOGIN_ERROR';

//# sourceMappingURL=LogEventIds.js.map
